module.exports = __webpack_public_path__ + "static/IMG_7880-240495d460f460d0308603bb9bc63bd6.jpg";